<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>添加决策模型</h3>
          </div>
        </div>
        <!-- <div class="div-step">
          <el-steps :active="0" align-center>
            <el-step title="添加决策模型"></el-step>
            <el-step title="关联环境模型"></el-step>
            <el-step title="关联生长模型"></el-step>
          </el-steps>
        </div> -->
      </div>
      <div class="container1">
        <div class="info-content-container">
          <div class="table_content1" style="margin-top: 10px">
            <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
              <el-row>
                <el-col :span="22">
                  <el-form-item label="分组名称：" prop="groupIdArr">
                    <el-cascader expand-trigger="hover" v-model="ruleForm.groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange" placeholder="请选择分组名称" collapse-tags clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="2">
                  <i title="添加更多分组" @click="handleAddMoreGroup()" class="el-icon-circle-plus-outline add-more"></i>
                </el-col> -->
              </el-row>
              <!--  -->
              <el-row>
                <el-col :span="22">
                  <el-form-item label="环境模型：" prop="modelEvnId">
                    <el-select v-model="ruleForm.modelEvnId" placeholder="请选择环境模型" clearable>
                      <el-option v-for="item in modelEvnArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="设备：" prop="deviceNumericalId">
                    <el-select v-model="ruleForm.deviceNumericalId" placeholder="请选择设备" clearable>
                      <el-option v-for="item in Numericals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="作物：" prop="cropId">
                    <el-select v-model="ruleForm.cropId" placeholder="请选择作物" clearable>
                      <el-option v-for="item in cropArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="生长模型：" prop="modelId">
                    <el-select v-model="ruleForm.modelId" placeholder="请选择生长模型" clearable @change="modelChange">
                      <el-option v-for="item in modelArray" :key="item.growthModelId" :label="item.growthModelName" :value="item.growthModelId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="2">
                  <i title="添加更多生长模型" @click="handleAddMoreGrowth()" class="el-icon-circle-plus-outline add-more"></i>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="生长阶段：" prop="modelStageId">
                    <el-select v-model="ruleForm.modelStageId" placeholder="请选择生长阶段" clearable @change="modelStageChange">
                      <el-option v-for="item in modelStageArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="细分阶段：" prop="modelTimeId">
                    <el-select v-model="ruleForm.modelTimeId" @change="getTime" placeholder="请选择细分阶段" clearable>
                      <el-option v-for="item in modelTimeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-col :span="2">
                  <i title="添加更多作物" @click="handleAddMoreCrop()" class="el-icon-circle-plus-outline add-more"></i>
                </el-col> -->
              <el-row>
                <el-col :span="24">
                  <el-form-item label="摄像头：">
                    <el-select v-model="ruleForm.deviceId" placeholder="请选择摄像头" clearable>
                      <el-option v-for="item in videoArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="排序号：" prop="orderNum">
                    <el-input-number v-model="ruleForm.orderNum" placeholder="请输入排序号" size="small" :max="9999" :min="1" :step="1" :precision="0" style="width: 100%"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="定植人员：" prop="plantName">
                    <el-input v-model="ruleForm.plantName" placeholder="请输入定植人员"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="定植日期：" prop="plantDate">
                    <el-date-picker disabled v-model="ruleForm.plantDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="肥料模型：" prop="growthModelFertilizerId">
                    <el-select v-model="ruleForm.growthModelFertilizerId" placeholder="请选择肥料模型" clearable>
                      <el-option v-for="item in fertilizerByUser" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="display: flex; justify-content: space-around">
              <div></div>
              <div class="pagination-container" style="margin-left: 12rem; margin-top: 3rem">
                <div class="page"></div>
                <div slot="footer" class="div-footer">
                  <el-button type="primary" @click="handleSave">保 存</el-button>
                  <!-- <el-button type="primary" @click="handleCheckData">检测数据完整</el-button>
                  <el-button type="primary" @click="handleCheckDevice">检测离线设备</el-button> -->
                </div>
              </div>
              <div style="margin-top: 4.5rem">
                <!-- <el-button type="primary" @click="handleNext">下一步</el-button> -->
                <el-button type="primary" @click="handleReturn">返回决策模型</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        // 添加编辑弹窗表单字段
        id: '',
        groupIdArr: [],
        groupId: '',
        cropId: '',
        orderNum: '',
        decisionId: '',
        groupId: '',
        deviceId: '',
        cropId: '',
        modelId: '',
        modelStageId: '',
        modelTimeId: '',
        growthModelFertilizerId: ''
      },
      videoArray: [],
      rules: {
        // 添加编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择分组名称',
            trigger: 'change'
          }
        ],
        cropId: [
          {
            required: true,
            message: '请选择作物',
            trigger: 'change'
          }
        ],
        orderNum: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'bluer'
          }
        ],
        deviceId: [
          {
            required: true,
            message: '请选择摄像头',
            trigger: 'change'
          }
        ],
        modelEvnId: [
          {
            required: true,
            message: '请选择环境模型',
            trigger: 'change'
          }
        ],
        deviceNumericalId: [
          {
            required: true,
            message: '请选择分组名称',
            trigger: 'change'
          }
        ],
        modelId: [
          {
            required: true,
            message: '请选择生长模型',
            trigger: 'change'
          }
        ],
        modelStageId: [
          {
            required: true,
            message: '请选择生长阶段',
            trigger: 'change'
          }
        ],
        modelTimeId: [
          {
            required: true,
            message: '请选择生长周期',
            trigger: 'change'
          }
        ]
      },
      modelEvnArray: [], // 大棚名称数组
      Numericals: [],
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      groupArray: [], // 分组名称数组
      cropArray: [], // 作物数组
      showRule: false,
      fertilizerByUser: []
    }
  },
  created() {
    this.ruleForm.id = this.$route.query.decisionId

    // 获取分组列表
    this.getGroupList()
    this.getGrowthModelFertilizerByUser()
    // 获取详情
    setTimeout(() => {
      this.getDetail()
    }, 500)
  },
  watch: {
    ruleForm: {
      handler(newValue, oldVal) {
        console.log(this.showRule)
        if (this.showRule) {
          this.showRule = false
          // console.log(newValue, oldVal, 659)
        }
      },
      deep: true // 深度监听
    }
  },
  methods: {
    getTime() {
      this.getPlanDate()
    },
    getPlanDate() {
      let form = {
        modelId: this.ruleForm.modelId,
        modelTimeId: this.ruleForm.modelTimeId
      }
      this.$api.growthModel.getPlanDate(form).then(res => {
        if (res.code == 200) {
          this.ruleForm.plantDate = res.data
        }
      })
    },
    getGrowthModelFertilizerByUser() {
      this.$api.growthModel.getGrowthModelFertilizerByUser().then(res => {
        if (res.code == 200) {
          this.fertilizerByUser = res.data
        }
      })
    },
    // 获取生长模型列表
    getGrowthModelAll() {
      this.$api.growthModel.getGrowthModelUsers().then(res => {
        if (res.code == 200) {
          this.modelArray = res.data
        }
      })
    },
    // 生长模型下拉切换
    modelChange() {
      // 清空
      this.ruleForm.modelStageId = ''
      // this.modelStageArray = []

      this.ruleForm.modelTimeId = ''
      // this.modelTimeArray = []

      // 获取生长阶段列表
      this.getGrowthModelStageAll()
    },
    // 获取生长阶段列表
    getGrowthModelStageAll() {
      // if (!this.ruleForm.modelId || this.ruleForm.modelId == '') {
      //   return
      // }

      this.$api.growthModel.getGrowthModelStageAll({ modelId: this.ruleForm.modelId }).then(res => {
        if (res.code == 200) {
          this.modelStageArray = res.data
          this.$forceUpdate()
          console.log(this.modelStageArray)
        }
      })
    },
    // 生长阶段下拉切换
    modelStageChange() {
      // 清空
      this.ruleForm.modelTimeId = ''
      this.modelTimeArray = []

      // 获取生长周期列表
      this.getGrowthModelTimeAll()
    },
    // 获取生长周期列表
    getGrowthModelTimeAll() {
      // if (!this.ruleForm.modelStageId || this.ruleForm.modelStageId == '') {
      //   return
      // }

      this.$api.growthModel.getGrowthModelTimeAll({ modelStageId: this.ruleForm.modelStageId }).then(res => {
        if (res.code == 200) {
          this.modelTimeArray = res.data
          this.$forceUpdate()
          console.log(this.modelTimeArray)
        }
      })
    },
    // 添加更多生长模型
    handleAddMoreGrowth() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: 'first'
        }
      })
    },
    // 获取环境模型列表
    getGrowthModelEvnAll() {
      if (!this.ruleForm.groupId || this.ruleForm.groupId == '') {
        return
      }

      this.$api.growthModel.getGrowthModelEvnAll({ groupId: this.ruleForm.groupId }).then(res => {
        if (res.code == 200) {
          this.modelEvnArray = res.data
        }
      })
      this.$api.device
        .getNumericalsByGroupId({
          groupId: this.ruleForm.groupId
        })
        .then(res => {
          this.Numericals = res.data
        })
    },
    // 添加更多环境模型
    handleAddMoreEvn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: 'second'
        }
      })
    },
    // 获取详情
    getDetail() {
      if (!this.ruleForm.id || this.ruleForm.id == '') {
        return
      }

      this.$api.growthModel.getGrowthModelDecision({ id: this.ruleForm.id }).then(async res => {
        if (res.code == 200) {
          this.ruleForm = res.data
          this.ruleForm.groupIdArr = [this.getParentGroupId(res.data.groupId), res.data.groupId]
          this.getGrowthCropAll()
          this.getVideoList()
          this.getGrowthModelEvnAll()
          this.getGrowthModelAll()
          this.getGrowthModelStageAll()
          this.getGrowthModelTimeAll()
          this.getPlanDate()
          setTimeout(() => {
            this.showRule = true
          }, 1000)
          console.log(this.showRule)
        }
      })
    },
    // 获取摄像头列表
    getVideoList() {
      if (!this.ruleForm.groupId || this.ruleForm.groupId == '') {
        return
      }

      this.$api.device.getVideosByGroupId({ id: this.ruleForm.groupId }).then(res => {
        if (res.code == 200) {
          this.videoArray = res.data
        }
      })
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '生长模型切换中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          this.$api.growthModel.saveGrowthModelDecision(this.ruleForm).then(res => {
            loading.close()
            if (res.code == 200) {
              this.ruleForm.id = res.data.decisionId
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.showRule = true
            }
          })
        }
      })
    },
    // 检测接口-数据完整
    handleCheckData() {
      if (!this.ruleForm.id || this.ruleForm.id == '') {
        this.$message({
          type: 'error',
          message: '请先添加决策模型'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '决策模型检测中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.$api.growthModel.checkGrowthModelDecisionData({ id: this.ruleForm.id }).then(res => {
        loading.close()
        if (res.code == 200) {
          if (res.data.checkFlag) {
            this.$message({
              type: 'success',
              message: '检测结果：数据完整'
            })
          } else {
            this.$message({
              type: 'error',
              message: '检测结果：数据不完整'
            })
          }
        }
      })
    },
    // 检测接口-离线设备
    handleCheckDevice() {
      if (!this.ruleForm.id || this.ruleForm.id == '') {
        this.$message({
          type: 'error',
          message: '请先添加决策模型'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '决策模型检测中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.$api.growthModel.checkGrowthModelDecisionOutlineDevices({ id: this.ruleForm.id }).then(res => {
        loading.close()
        if (res.code == 200) {
          let msg = ''
          res.data.forEach(val => {
            if (msg.length > 0) {
              msg += ','
            }
            msg += val.deviceName + '-' + val.attributeName
          })

          if (msg == '') {
            msg = '无'
          }

          this.$message({
            type: 'error',
            message: '离线设备：' + msg
          })
        }
      })
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]

      // 清空
      this.ruleForm.cropId = ''
      this.cropArray = []
      this.getGrowthCropAll()
      this.getVideoList()
      this.getGrowthModelEvnAll()
      this.getGrowthModelAll()
      // this.getGrowthModelStageAll()
      this.getGrowthModelTimeAll()
      // 获取作物列表
      this.getGrowthCropAll()
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then(res => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map(item => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 获取作物列表
    getGrowthCropAll() {
      this.$api.growthModel.getGrowthCropAll({ id: this.ruleForm.groupId }).then(res => {
        if (res.code == 200) {
          this.cropArray = res.data
        }
      })
    },
    // 添加更多大棚
    handleAddMoreGroup() {
      this.$router.push({
        name: `deviceManagement`,
        query: {
          activeName2: 'first',
          activeName3: 'first'
        }
      })
    },
    // 添加更多作物
    handleAddMoreCrop() {
      this.$router.push({
        name: `cropsManagement`,
        query: {}
      })
    },
    // 返回
    handleReturn() {
      if (this.showRule) {
        this.$router.push({
          name: `decisionManagement`,
          query: {}
        })
      } else {
        this.$message({
          type: 'error',
          message: '请先保存内容再返回'
        })
      }
    },
    // 下一步
    handleNext() {
      if (!this.ruleForm.id || this.ruleForm.id == '') {
        this.$message({
          type: 'error',
          message: '请先添加决策模型'
        })
        return
      }

      this.$router.push({
        name: `relationEvnModel`,
        query: {
          decisionId: this.ruleForm.id,
          groupId: this.ruleForm.groupId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 10px;
    margin-right: 10px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 600px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }

  .add-more {
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    color: #256bff;
    cursor: pointer;
  }
}
</style>
